<!DOCTYPE html>
<html lang="pt-BR">

<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Política de Privacidade</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      margin: 20px;
      padding: 20px;
      line-height: 1.6;
      background-color: #f9f9f9;
    }

    .container {
      max-width: 800px;
      margin: auto;
      background: white;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    }

    h1,
    h2 {
      color: #333;
    }

    ul {
      margin-top: 0;
    }
  </style>
</head>

<body>
  <div class="container">
    <h1>Política de Privacidade</h1>

    <h2>1. Introdução</h2>
    <p>Bem-vindo ao nosso aplicativo de checklist de máquinas agrícolas. A sua privacidade é importante para nós. Esta
      Política de Privacidade explica como coletamos, usamos e protegemos seus dados ao utilizar nosso aplicativo.</p>

    <h2>2. Coleta de Dados</h2>
    <p>Nosso aplicativo pode coletar as seguintes informações:</p>
    <ul>
      <li>Dados pessoais fornecidos pelo usuário, como nome e e-mail, quando aplicável.</li>
      <li>Dados sobre uso do aplicativo, como listas de checklist criadas e status das inspeções.</li>
      <li>Informações do dispositivo, como modelo e sistema operacional, para fins de suporte técnico.</li>
    </ul>

    <h2>3. Uso dos Dados</h2>
    <p>Os dados coletados são utilizados para:</p>
    <ul>
      <li>Melhorar a experiência do usuário e aprimorar o funcionamento do aplicativo.</li>
      <li>Fornecer suporte técnico e responder a dúvidas.</li>
      <li>Garantir conformidade com nossas políticas e requisitos legais.</li>
    </ul>

    <h2>4. Compartilhamento de Dados</h2>
    <p>Não compartilhamos seus dados pessoais com terceiros, exceto nos seguintes casos:</p>
    <ul>
      <li>Para cumprir obrigações legais ou regulatórias.</li>
      <li>Com prestadores de serviço que auxiliam no funcionamento do aplicativo, garantindo que sigam as normas de
        privacidade.</li>
    </ul>

    <h2>5. Armazenamento e Segurança dos Dados</h2>
    <p>Os dados são armazenados em servidores seguros e protegidos contra acessos não autorizados. Implementamos medidas
      técnicas e administrativas para garantir a segurança das informações coletadas.</p>

    <h2>6. Permissões do Aplicativo</h2>
    <p>Nosso aplicativo pode solicitar permissões para acessar determinados recursos do dispositivo, como câmera ou
      armazenamento, sempre informando o motivo e solicitando consentimento do usuário.</p>

    <h2>7. Anúncios</h2>
    <p>Nosso aplicativo <strong>não exibe anúncios</strong> e não compartilha dados com redes de publicidade.</p>

    <h2>8. Uso Restrito a Maiores de 18 Anos</h2>
    <p>Nosso aplicativo é destinado exclusivamente para usuários maiores de 18 anos. Ao utilizar o aplicativo, você
      declara ser maior de idade.</p>

    <h2>9. Alterações nesta Política</h2>
    <p>Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos os usuários sobre mudanças
      significativas por meio do aplicativo ou de outro meio adequado.</p>

    <h2>10. Contato</h2>
    <p>Se tiver dúvidas sobre esta Política de Privacidade, entre em contato conosco pelo e-mail: <a
        href="mailto:contato&#64;buildtec.com.br">contato&#64;buildtec.com.br</a>.</p>
  </div>
</body>

</html>
